var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-button',{attrs:{"icon":"el-icon-back","type":"text","size":_vm.size},on:{"click":_vm.goBack}},[_vm._v("返回")]),(_vm.title)?_c('el-divider',{attrs:{"direction":"vertical"}}):_vm._e(),(_vm.title)?_c('span',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"pull-right"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }